import { ComponentHeaderAuth, ComponentQRcode, StyledHome } from "@components";
import { PATH_HOME } from "@configs";
import { selectMerchant } from "@redux";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

export const PageMyQR = () => {
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);
    const [showQrCode, setShowQrCode] = useState<boolean>(false);
    const handleInitalQrCode = () => {
        setShowQrCode(false);
    };
    const handleToggleQrCode = () => {
        history.push(PATH_HOME);
    };
    return (
        <ComponentHeaderAuth handleInitalQrCode={handleInitalQrCode}>
            <StyledHome mainColor={themes?.themeColor!}>
                <ComponentQRcode handleToggleQrCode={handleToggleQrCode} />
            </StyledHome>
        </ComponentHeaderAuth>
    );
};
